import { Directive, HostBinding, Input } from '@angular/core';

/**
 * The directive highlights an icon when the host element has focus using CSS styles.
 *
 * Example:
 * ```html
 * <a href="#" mcIconHighlight color="link" routerLink="/foobar">
 *   <mat-icon class="mc-image-icon" fontSet="project-titan" fontIcon="icon-info"></mat-icon>
 * </a>
 * ```
 * In this example the mc-image-icon class is used to make the icon use its intrinsic size instead of a fixed size.
 */
@Directive({
  selector: '[mcIconHighlight]'
})
export class IconHighlightDirective {
  @Input() color: string;

  @HostBinding('class') get hostClasses(): string {
    return `mc-icon-highlight ${this.color ? 'mat-' + this.color : ''}`;
  }
}
